import React from 'react'
import {Link} from 'react-router-dom'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux'
import "./navbar.css"
import {
    Collapse,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
  } from "reactstrap";

const Navbar = (props) => {
    const { auth, profile } = props;
    //console.log(auth);
    const links = auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />;
    return (
        <nav className="nav" >
            <div className='logo'> 
            <NavbarBrand href="/" className="brand-logo">
            <span className="text-1">สื่อ</span>
            <span className="text-2">การ</span>
            <span className="text-3">เรียน</span>
            <span className="text-4">ออน</span>
            <span className="text-5">ไลน์ </span>
          </NavbarBrand> 
                { links }
            </div>
        </nav>
    )
}

const mapStateToProps = (state) => {
    console.log(state);
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile
    }
} 

export default connect(mapStateToProps)(Navbar)